<script>
    export default {
        props: {
            item: Object
        }
    }
</script>

<template>
    <div class="cancellation-item">
        <div class="cancellation-item-header"> {{item.group}} </div>
        <ul class="cancellation-list">
            <li v-for="flight in item.items" :key="flight.flightKey">
                <span class="cancellation-flight-number">F9 {{flight.flightNumber}}:&nbsp;</span>
                <span class="cancellation-flight-cities">{{flight.origin}}-{{flight.destination}}</span>
            </li>
        </ul>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .cancellation-item {
        padding: 10px 0;
        color: @frontier-gray-dark;

        .cancellation-item-header {
            font-weight: 600;
            font-size: 16px;
            white-space: nowrap;
        }

        .cancellation-list {
            font-size: 14px;
        }
    }

    @media @tablet {
        .cancellation-item {
            padding: 5px 0;

            .cancellation-item-header {
                font-size: 14px;
            }

            .cancellation-list {
                font-size: 12px;
            }
        }
    }
</style>

